/** Legacy catalog sentinel in `dependency`: no parent type for map bind lookup. */
export const INVENTORY_MAP_NO_BIND_DEPENDENCY = 3
